import styled, { css } from 'styled-components';
import { SimpleGridWrapperProps } from '../types/SectionFeatureRow.types';

export const imageContainer = css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
`;

export const imageBlock = css`
    display: block;
    width: 65px;
    height: 65px;
`;

export const assessmentPage = css`
    display: block;
    width: 100%;
    height: 100%;
    max-width: 849px;
    margin-top: -6em;
    @media (max-width: 600px) {
        margin-top: -4em;
        padding: 6%;
    }
`;

export const SimpleGridWrapper = styled.div<SimpleGridWrapperProps>`
    margin: 0 auto;
    min-width: 300px;
    padding: 0 10px;
    max-width: ${({ size }) => (size === 'small' ? "400px" : size === 'medium' ? '780px' : '1200px')};

    [class*='SimpleGridstyle__SimpleGrid-sc'] {
        display: flex;
        justify-content: space-evenly;

        [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
            margin: 0;
        }
    }
`;